import { runWithQoS, Feature } from '../../../shared';
import ContactsAPIClient from 'owa-contacts-api';

export function deleteContact(contactId: string): Promise<Response> {
    return runWithQoS<Response>({
        scenarioName: 'DeleteContact',
        feature: Feature.ContactManagement,
        operation: ContactsAPIClient.DeleteContact(contactId),
    });
}
